<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M14.75 9.5V11.75C14.75 13.4069 13.4069 14.75 11.75 14.75H3.75C2.09315 14.75 0.75 13.4069 0.75 11.75V3.75C0.75 2.09315 2.09315 0.75 3.75 0.75H6" stroke="#232323" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M14.75 6V0.75H9.5M14.75 0.75L7.75 7.75" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<style lang="css" scoped>
</style>

<script>
export default {
  name: 'IconShare'
}
</script>
